import styled from "@emotion/styled";
import { defaultDesingItems as dD } from "utils/constants";
import { get, isBoolean } from "lodash";

export const StyledCard = styled.div`
    overflow: hidden;
    box-shadow: 0px 1px 45px rgba(110, 96, 132, 0.1);
    width: 100%;
    height: 100%;
    border-radius: 16px;
    background: white;
    position: relative;
    z-index: 22;
    display: flex;
    flex-direction: column;
    color: ${(props) => get(props, "design.colors.text", dD.colors.text)};
    position: relative;

    .pet_icon {
        width: 32px;
        height: 32px;
        position: absolute;
        top: 20px;
        left: 25px;
        z-index: 99;
    }

    .cardBtn {
        &.selected button {
            background: ${() => dD.colors.primary} !important;
            color: ${() => dD.colors.button} !important;
            border-color: transparent !important;
        }
        button {
            gap: 15px;
            height: 48px;
            min-width: 120px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            outline: none;
            padding-inline: 17px;
            border: ${(props) =>
                isBoolean(
                    get(props, "design.bookBtn.border")
                        ? get(props, "design.bookBtn.border")
                        : dD.bookBtn.border
                )
                    ? "1px solid"
                    : "none"};
            background: ${(props) =>
                get(props, "design.bookBtn.background", dD.bookBtn.background)};
            border-color: ${(props) => get(props, "design.bookBtn.color", dD.bookBtn.color)};
            border-radius: ${(props) => get(props, "design.bookBtn.radius", dD.bookBtn.radius)}px;
            span {
                font-size: 14px;
                font-weight: 600;
                color: ${(props) => get(props, "design.bookBtn.color", dD.bookBtn.color)};
            }
            svg {
                font-weight: 400;
                width: 20px;
                color: ${(props) => get(props, "design.bookBtn.icon", dD.bookBtn.icon)};
            }
        }
        padding: 16px;
        display: flex;
        width: 100%;
        justify-content: end;
        gap: 20px;
    }
    display: flex;
    flex-direction: column;
    .swiper-wrapper {
        height: 260px;
    }
    .swiperCard {
        position: relative;
        .top-text {
            position: absolute;
            width: 175px;
            height: 35px;
            z-index: 20;
            border-bottom-left-radius: 18px;
            top: 0;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 600;
            font-size: 15px;
            line-height: 24px;
            background-color: ${(props) =>
                get(props, "design.recommend.background", dD.recommend.background)};
            color: ${(props) => get(props, "design.recommend.color", dD.recommend.color)};
        }
        width: 100%;
        height: 266px;
        .swiper {
            width: 100%;
            height: 100%;
        }
        .swiper-slide {
            text-align: center;
            font-size: 18px;
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .swiper-pagination {
            margin-bottom: 40px;
        }
        .swiper-pagination-bullet-active {
            border: 3px solid white;
            background-color: inherit;
        }

        .swiper-slide img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        /* Iconlar turgan joy */
        .swiper-bottom {
            position: absolute;
            bottom: 5px;
            padding: 16px;
            background: rgba(0, 0, 0, 0.5);
            z-index: 9;
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: white;
            .left {
                display: flex;
                gap: 8px;
                div {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    p {
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 15px;
                    }
                }
            }
            .right {
                img {
                    max-width: 100%;
                    object-fit: cover;
                }
                display: flex;
                gap: 20px;

                div {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    p {
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 15px;
                    }
                }
            }
        }
    }
    /* Swiper Card End */

    /* Card content */
    .cardContent {
        padding: 16px 16px 0 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        flex: 1;
        .DescriptionCard {
            font-weight: 600;
            font-size: 18px;
            line-height: 123.9%;
        }
        .contentText {
            display: flex;
            justify-content: space-between;
            flex: 1;
            .left {
                color: ${(props) => get(props, "design.colors.text", dD.colors.text) + "95"};
                font-weight: 500;
                font-size: 13px;
                line-height: 21px;
                white-space: break-spaces;
                text-overflow: ellipsis;
                overflow: hidden;
                display: inline-block;
                max-width: 60%;
            }
            .right {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                justify-content: flex-end;
                h3 {
                    text-decoration: line-through;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 23px;
                }
                h2 {
                    font-size: 20px;
                    line-height: 23px;
                    span {
                        font-weight: 500;
                        font-size: 14px;
                    }
                }
            }
            h3,
            h2 {
                margin: 0;
            }
            display: flex;
        }
    }

    @media (max-width: 395px) {
        .contentText {
            .left {
                font-size: 13px !important;
                line-height: 21px !important;
            }
            .right {
                h3,
                h2 {
                    font-size: 18px !important;
                    line-height: 21px !important;
                }
                .days {
                    font-size: 10px !important;
                    line-height: 21px !important;
                }
            }
        }
    }
    @media (max-width: 350px) {
        .contentText {
            .left {
                font-size: 11px !important;
                line-height: 21px !important;
            }
            .right {
                h3,
                h2 {
                    font-size: 18px !important;
                    line-height: 21px !important;
                }
                .days {
                    font-size: 10px !important;
                    line-height: 21px !important;
                }
            }
        }
    }
    /* Card Content End */
`;
